<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <v-row class="justify-center">
        <v-col cols="12" md="6">
          <v-card class="pa-6">
            <div class="text-center">
              <v-icon size="120" color="warning" class="mb-4">
                mdi-shield-lock-outline
              </v-icon>
              <h1 class="text-h4 font-weight-bold mb-2">403</h1>
              <h2 class="text-h5 mb-4">Không có quyền truy cập</h2>
              <p class="text--secondary mb-6">
                Bạn không có quyền truy cập trang này. Vui lòng liên hệ quản trị viên nếu bạn cho rằng đây là lỗi.
              </p>
              
              <div class="d-flex justify-center">
                <v-btn
                  color="primary"
                  class="mr-2"
                  @click="goBack"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  Quay lại
                </v-btn>
                
                <v-btn
                  color="info"
                  outlined
                  @click="goHome"
                >
                  <v-icon left>mdi-home</v-icon>
                  Trang chủ
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page403',
  
  created() {
    // Log access attempt for security monitoring
    // 403 Access Denied: this.$route.fullPath
  },
  
  methods: {
    goBack() {
      // Go back to previous page
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.goHome()
      }
    },
    
    goHome() {
      // Redirect to appropriate home page based on role
      const accountInfo = this.$store.state.accountInfo
      if (!accountInfo || !accountInfo.roleId) {
        this.$router.push('/login')
        return
      }
      
      // Redirect based on role
      switch (accountInfo.roleId) {
        case 1: // ADMIN
          this.$router.push('/account')
          break
        case 2: // AGENCY
          this.$router.push('/hospital')
          break
        case 3: // HOSPITAL_MANAGEMENT
          this.$router.push('/dashboard')
          break
        default:
          this.$router.push('/dashboard')
      }
    }
  }
}
</script>

<style scoped>
.app {
  min-height: 100vh;
  background-color: #f5f5f5;
}
</style>